export enum ReportTableType {
  EVENT = 'Event',
  PICTURE_DAY = 'Picture day',
  NOT_UPLOADED_EVENT = 'Not Uploaded Event',
  QUARANTINE_EVENT = 'Quarantine Event',
  EM_COMPLETION_STATUS = 'EM Completion Status'
}